import { createContext, useContext, ReactNode } from 'react';
import { isMobile, isTablet } from 'react-device-detect';

interface DeviceContextType {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
}

const DeviceContext = createContext<DeviceContextType>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
});

export function DeviceProvider({ children }: { children: ReactNode }) {
    const value: DeviceContextType = {
        isMobile: isMobile && !isTablet,
        isTablet: isTablet,
        isDesktop: !isMobile && !isTablet,
    };

    return (
        <DeviceContext.Provider value={value}>
            {children}
        </DeviceContext.Provider>
    );
}

export function useDevice() {
    return useContext(DeviceContext);
}
